import { render, staticRenderFns } from "./ScheduleSendModal.vue?vue&type=template&id=b50c6a28&scoped=true"
import script from "./ScheduleSendModal.vue?vue&type=script&lang=js"
export * from "./ScheduleSendModal.vue?vue&type=script&lang=js"
import style0 from "./ScheduleSendModal.vue?vue&type=style&index=0&id=b50c6a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50c6a28",
  null
  
)

export default component.exports